module.exports = function(options) {

    return {
        ...options,

        // Overwrite options
        // language: 'en',

        /*
        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: { 'class': '' } },
            { name: 'Primary button', element: 'a', attributes: { 'class': 'btn-galaxy-primary' } },
        ],
        */

    };

};